/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { Fragment } from 'react'
import {
  useComponent,
  useMeta,
  useComponentMeta,
  useDataSelector,
  useDoHydrateComponent,
  usePalette as useGetPaletteFromEntity,
} from '../selectors'
import ConditionalHydrate from '../conditional-hydrate'

import ModMarker, { displayModMarker } from './module-marker'

import { isEmpty } from '../../../utils/obj'

import { useTrackModule, ComponentTrackingContext } from '../../../utils/component-events'
import { ModuleContainer } from './module-container'
import { usePalette, createSx } from '../../../utils/palette'

const px = {
  background: 'background',
  backgroundColor: 'backgroundColor',
  color: 'textColor',

  'h1, h2, h3, h4, h5, h6, a, strong, b': {
    color: 'accentTextColor',
  },
}

const EVComponent = (props) => {
  const [err, C, wrapperConfig, features] = useComponent(props)
  const { publishDate, updatedDate } = useDataSelector(['dates'], {})
  const id = props.id || props.sys?.id
  const doHydrateComponent = useDoHydrateComponent(id)
  const doHydrate = props.forceHydrate || doHydrateComponent

  const { trackComponent, trackProps } = useTrackModule(props)

  const paletteFromContext = usePalette()
  const paletteFromProp = useGetPaletteFromEntity(props.palette)
  const { sys: { contentTypeId } = {}, variant: v, variants } = props
  const variant = v ?? variants
  const { defaultPalette: defaultVariantPalette } = useComponentMeta(contentTypeId, variant, {})
  const { defaultPalette: defaultComponentPalette } = useComponentMeta(contentTypeId, undefined, {})
  const defaultPalette = { ...defaultComponentPalette, ...defaultVariantPalette }
  const customPalette = !isEmpty(paletteFromProp) ? paletteFromProp : paletteFromContext
  const wrapperConfigPalette = wrapperConfig?.palette
  const palette = { ...defaultPalette, ...customPalette, ...wrapperConfigPalette }

  const sx = { ...createSx(palette, px) }

  const deactivateMarginCollapse = useMeta(['deactivateMarginCollapse'], false)

  if (deactivateMarginCollapse || !isEmpty(palette)) {
    sx.py = '0.05px'
  }

  // TODO: Handle errors in finding the component
  if (err) {
    // eslint-disable-next-line no-console
    console.log({ err })
    return null
  }

  const additionalProps = {}

  if (features?.localDates) {
    additionalProps.localDates = {
      dateCreated: props?.sys?.createdAt,
      dateUpdated: props?.sys?.updatedAt,
    }
  }

  if (features?.globalDates) {
    additionalProps.globalDates = {
      dateCreated: publishDate,
      dateUpdated: updatedDate,
    }
  }

  return (
    <Fragment>
      {displayModMarker() && <ModMarker entity={props} />}
      <ConditionalHydrate
        force={doHydrate}
        As='div'
        sx={{ position: 'relative', ...sx }}
        data-component-tracking={JSON.stringify(trackProps)}
      >
        <ModuleContainer
          wrapperConfig={wrapperConfig}
          spacing={props.spacing}
          removeTopSpacing={props.removeTopSpacing}
          removeBottomSpacing={props.removeBottomSpacing}
          variant={variant}
          moduleSpacing={props.moduleSpacing}
          entryUseContainer={props.useContainer}
        >
          <ComponentTrackingContext.Provider value={trackComponent}>
            <C {...props} {...additionalProps} />
          </ComponentTrackingContext.Provider>
        </ModuleContainer>
      </ConditionalHydrate>
    </Fragment>
  )
}

export default EVComponent
